import { TText } from 'platejs';

export const formatNode = (child: TText) => {
	//console.log(child, 'child');
	let string = ``;

	if (child.bold) {
		string += `<b>`;
	}

	if (child.italic) {
		string += `<i>`;
	}

	if (child.underline) {
		string += `<u>`;
	}

	if (child.strikethrough) {
		string += `<s>`;
	}

	if (child.code) {
		string += `<code>`;
	}

	if (child.spoiler) {
		string += `<span class="tg-spoiler">`;
	}

	if (child.affiliateLink) {
		string += `<a href="{affiliate_link}">`;
	}

	string += child.text;

	if (child.affiliateLink) {
		string += `</a>`;
	}

	if (child.spoiler) {
		string += `</span>`;
	}

	if (child.code) {
		string += `</code>`;
	}

	if (child.strikethrough) {
		string += `</s>`;
	}

	if (child.underline) {
		string += `</u>`;
	}

	if (child.italic) {
		string += `</i>`;
	}

	if (child.bold) {
		string += `</b>`;
	}

	return string;
};
